module.exports = __webpack_public_path__ + "media/images/icons/instagram-bc4da85e326eb7f88dc2248f56f5cd61.svg";